import React from 'react'
import { motion } from 'framer-motion'
import styled from 'styled-components'

const PageWrapper = styled(motion.div)`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`

const pageVariants = {
  initial: {
    opacity: 0,
    y: 20,
  },
  in: {
    opacity: 1,
    y: 0,
  },
  out: {
    opacity: 0,
    y: -20,
  },
}

const pageTransition = {
  type: 'tween',
  ease: 'anticipate',
  duration: 0.5,
}

interface PageTransitionProps {
  children: React.ReactNode
}

export const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  return (
    <PageWrapper
      initial='initial'
      animate='in'
      exit='out'
      variants={pageVariants}
      transition={pageTransition}>
      {children}
    </PageWrapper>
  )
}
